import { Dispatch } from 'redux';
import Echo from 'laravel-echo';

import City from '../../types/City';

import {
  addCity,
  updateCity,
  deleteCity,
} from '../../redux/reducers/CitiesReducer';

export default function subscribeToCitiesChannel(
  echo: Echo,
  dispatch: Dispatch,
) {
  echo
    .private('cities')
    .listen('Cities\\CityCreated', ({ city }: { city: City }) => {
      dispatch(addCity(city));
    });

  echo
    .private('cities')
    .listen('Cities\\CityUpdated', ({ city }: { city: City }) => {
      dispatch(updateCity(city));
    });

  echo
    .private('cities')
    .listen('Cities\\CityDeleted', ({ id }: { id: number }) => {
      dispatch(deleteCity(id));
    });
}
